import React, { Component } from 'react'
import styles from './student-details.styles'
import injectSheet from 'react-jss'
import Container from '../../shared/container/container'
import Main from '../../shared/main/main'
import Paper from 'pobble-components/dist/paper'
import Spinner from 'pobble-components/dist/spinner'
import StudentDetailsComponent from './student-details-component/student-details-component'

class StudentDetails extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <Container>
        <Main>
          <Paper className={classes.paper}>
            {pending && <Spinner />}
            {!pending && <StudentDetailsComponent />}
          </Paper>
        </Main>
      </Container>
    )
  }
}

export default injectSheet(styles)(StudentDetails)
